<template>
  <div class="content">
    <div class="top">
<!--      platformStr:{{platformStr}}-->
      <template v-if="platformStr">
        <template v-if="platformStr === 'haoyin'">
          <img src="../../../assets/img/logoProxy.png" alt="">
          <div class="top-text">好影影票</div>
        </template>
        <template v-if="platformStr === 'youyv' || platformStr === 'ceshi'">
          <img style="width:32px;height: 32px;" src="../../../assets/img/logoProxy-yy.png" alt="">
          <div class="top-text">有鱼电影</div>
        </template>
      </template>
    </div>
    <div class="center">
      <div class="box">
        <div class="box-title">全国电影院85折</div>
        <div class="box-text">最低3折起，推广立即赚钱</div>
        <img src="../../../assets/img/login_pic.png" alt="">
      </div>
      <div class="login-action">
        <div class="login-padding">
          <div class="login-title">登录</div>
          <div class="input-wrap" :style="errorInfo.mobileWrapObj">
            <img src="../../../assets/img/login_btn_user.png" alt="">
            <input type="text" placeholder="请输入手机号" v-model.trim="nickname" @blur="checkNickname">
            <img v-show="nickname" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('nickname')">
          </div>
          <div class="input-tip" :style="errorInfo.mobileTipObj">
            <Icon type="md-alert" size="24" color="#FF4F76" />
            <span class="tip-content">{{ errorInfo.mobileTip }}</span>
          </div>
          <div class="input-wrap last" :style="errorInfo.passwordWrapObj">
            <img src="../../../assets/img/login_btn_password.png" alt="">
            <input type="password" placeholder="请输入密码" v-model.trim="password" @input="checkPassword">
            <img v-show="password" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('password')">
          </div>
          <div class="input-tip" :style="errorInfo.passwordTipObj">
            <Icon type="md-alert" size="24" color="#FF4F76" />
            <span class="tip-content">{{ errorInfo.passwordTip }}</span>
          </div>
          <div class="operate-wrap">
            <div class="forget-pwd" @click="toForgetPwd">忘记密码？</div>
            <div class="to-register" @click="toRegister">注册账号</div>
          </div>
          <div class="to-login" @click="doLogin">登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Icon
} from 'view-design'
import { mapState } from 'vuex';
import {findKeyByUrl} from '@/utils/platform.js'
export default {
  name: "index",
  components: {
    Icon
  },
  data() {
    return {
      errorInfo: {
        mobileTip: '',
        passwordTip: '',
        mobileTipObj: {
          display: 'none'
        },
        passwordTipObj: {
          display: 'none'
        },
        mobileWrapObj: {
          border: '1px solid #eeeeee'
        },
        passwordWrapObj: {
          border: '1px solid #eeeeee' // ff4f76
        }
      },
      nickname: '',
      password: '',
      loading: false,
      // 代理域名
      // platformStr:localStorage.getItem('platformStr'),
    }
  },
  created() {
    this.$store.commit('user/SET_PROXY_URL')
  },
  computed: {
    ...mapState({
      // 通过 mapState 从 store 中的 user 模块获取 userInfo
      proxyUrl: (state) => state.user.proxyUrl,
      platformStr:(state) => state.user.platformStr,
    }),
  },
  // watch:{
  //   proxyUrl: {
  //     handler(newValue, oldValue) {
  //       console.log(newValue,'proxyUrl 发生了变化:', oldValue);
  //       console.log(findKeyByUrl(newValue),'SSSD==')
  //       let type = findKeyByUrl(newValue)
  //       this.platform = type
  //       localStorage.setItem('platformStr',type)
  //     },
  //     deep: true, // 深度监听
  //     immediate:true,
  //   },
  // },
  mounted() {
    // 代理
    this.$store.commit('user/SET_APP_TYPE', {
      isSaasProxyUser: 1,
      isDyAppOwner: 0
    })
  },
  methods: {
    //跳转到登录界面
    toRegister() {
      this.$router.push('/pc/register')
    },
    toForgetPwd() {
      this.$router.push('/pc/resetPwd')
    },
    //监听密码
    checkPassword() {
      var isValidate = true
      var tip = ''
      if (this.password === '') {
        tip = '请填写密码'
        isValidate = false
        return this.handelErrorTip(isValidate, 1, tip)
      }
      if (!(this.password.length >= 6)) {
        tip = '密码长度错误'
        isValidate = false
        return this.handelErrorTip(isValidate, 1, tip)
      }
      tip = ''
      isValidate = true
      return this.handelErrorTip(isValidate, 1, tip)
    },
    handelErrorTip: function (isValidate, type, tip) {
      if (type == 0) {
        if (isValidate === false) {
          this.errorInfo.mobileTip = tip
          this.errorInfo.mobileTipObj.display = 'flex'
          this.errorInfo.mobileWrapObj.border = '1px solid #FF9734'
        } else {
          this.errorInfo.mobileTip = ''
          this.errorInfo.mobileTipObj.display = 'none'
          this.errorInfo.mobileWrapObj.border = '1px solid #E8E8E8'
        }
      } else {
        if (isValidate === false) {
          this.errorInfo.passwordTip = tip
          this.errorInfo.passwordTipObj.display = 'flex'
          this.errorInfo.passwordWrapObj.border = '1px solid #FF9734'
        } else {
          this.errorInfo.passwordTip = ''
          this.errorInfo.passwordTipObj.display = 'none'
          this.errorInfo.passwordWrapObj.border = '1px solid #E8E8E8'
        }
      }
      return isValidate
    },
    //监听昵称或手机号
    checkNickname() {
      var isValidate = true
      var tip = ''
      if (this.nickname === '') {
        tip = '请填写手机号'
        isValidate = false
        return this.handelErrorTip(isValidate, 0, tip)
      }
      var numReg = /^[0-9]*$/
      var numRe = new RegExp(numReg)
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.nickname))) {
        tip = '手机号格式错误'
        isValidate = false
        return this.handelErrorTip(isValidate, 0, tip)
      }
      isValidate = true
      tip = ''
      return this.handelErrorTip(isValidate, 0, tip)
    },
    doLogin() {
      var isValidate = this.allValidate()
      if (isValidate === false) {
        return
      }
      this.loading = true
      var loginFormData = {
        mobile: this.nickname,
        password: this.password
      }
      this.$store.dispatch('user/login', loginFormData).then((response) => {
        let userInfo = response.data.userInfo
        if(userInfo.saas_dy_app_url && this.$domain !== 'localhost:8080'){
          this.$store.commit('user/SET_ISLOGIN', false)
          this.navShow = false
          this.$confirm(userInfo.saas_dy_app_tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch('nav/changeIsGoOfficial', 0)
            this.$store.dispatch('user/logout')
            localStorage.removeItem('java-token')
            localStorage.removeItem('java-open-token')
            this.$Message.success('退出成功')
            this.$store.commit('user/SET_TOKEN', '')
            this.$store.commit('user/SET_NICKNAME', '')
            // window.location.href = userInfo.saas_dy_app_url
            window.open(userInfo.saas_dy_app_url)
          }).catch(() => {
            this.$store.dispatch('nav/changeIsGoOfficial', 0)
            this.$store.dispatch('user/logout')
            this.$router.push({
              path:'/pc/proxyHome/index',
            })
          });
          return
        }
        this.$store.commit('user/SET_APP_TYPE', {
          isSaasProxyUser: userInfo.is_saas_proxy_user,
          isDyAppOwner: userInfo.is_dy_app_owner
        })
        this.loading = false
        this.isLogin = true
        this.nickname = this.password = ''
        this.$Message.success('登录成功')
        localStorage.setItem('leadUUID', userInfo.leadUUID)
        // if (userInfo.leadUUID != 0) {
        //   this.$router.push({
        //     path: '/pc/bypassAccountOrder/ApiOrder'
        //   })
        // }
        console.log(userInfo.is_dy_app_owner,'userInfo.is_dy_app_owner===33')
        if(userInfo.is_saas_proxy_user !== 0 && userInfo.is_dy_app_owner !== 1) {
          console.log('代理===11112')
          localStorage.setItem('isSelect', 0)
        }else{
          console.log('好影==22223')
          localStorage.setItem('isSelect', 4)
        }
        this.$router.push({
          path: '/pc/douyin/home/index'
        })
        // this.$store.dispatch('nav/changeMovieShowDialog', true)

        //获取用户信息
        // this.$store.dispatch('user/getInfo').then((response) => {
        //   // 如果之前用户从公众号那边入驻进来的
        //
        //   let isGoOfficial = this.$store.getters.isGoOfficial
        //   if(isGoOfficial == 1){
        //     let param = this.$route.param
        //     // 是否购买了套餐
        //     let hasPackage =   getHasPackage() === 'true' ? true : false
        //     if(hasPackage){
        //       this.$store.dispatch('nav/changeOfficialAccountActiveIndex',0)
        //       this.$router.push({
        //         path: '/pc/official/statistics',
        //         query:param
        //       })
        //     }else{
        //       this.$store.dispatch('nav/changeOfficialAccountActiveIndex',0)
        //       // 便于sildeNav 触发change数据
        //       this.$router.push({
        //         path: '/pc/official/dialog',
        //         query:param
        //       })
        //     }
        //   }else{
        //     this.$router.push({
        //       path: '/pc/promotion/home',
        //       query: this.otherQuery
        //     })
        //   }
        //
        // }).catch(() => {})
      }).catch(() => {
        this.loading = false
      })
    },
    allValidate() {
      return (this.checkNickname() && this.checkPassword())
    },
    //清除文本框
    clear(val) {
      this[val] = ''
    },
  }
}
</script>

<style scoped lang="less">
.content {
  background-image: url("../../../assets/img/login_bg.png");
  background-size: 100% 100%;
  height: 100%;
  padding: 20px 34px;

  .center {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 70%;
    margin: auto;

    .box {
      &-title {
        font-size: 54px;
        font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 74px;
      }

      &-text {
        font-size: 20px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 27px;
        margin-top: 10px;
      }

      img {
        margin-top: 44px;
      }
    }
  }
}

.login-action {
  background: #ffffff;
  width: 460px;
  height: 476px;
  float: right;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
}

.login-action .login-padding {
  padding: 60px;
}

.login-action .login-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 32px;
  color: #222222;
  text-align: center;
}

.login-action .input-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 10px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-top: 20px;
}

.login-action .input-wrap img {
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.login-action .input-wrap input {
  width: 90%;
  font-size: 14px;
  color: #222222;
  padding: 5px;
  border: none;
}

.login-action .input-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #ff4f76;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.login-action .input-tip.hidden {
  display: none;
}

.login-action .input-tip .tip-content {
  margin-left: 3px;
  color: #ff4f76;
}

::-webkit-input-placeholder {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}

.operate-wrap {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
  width: 100%;
  overflow: hidden;
}

.operate-wrap .forget-pwd {
  float: left;
  cursor: pointer;
}

.operate-wrap .to-register {
  float: right;
  cursor: pointer;
}

.to-login {
  color: #ffffff;
  background: #ff9734;
  border-radius: 2px;
  margin-top: 40px;
  text-align: center;
  height: 48px;
  line-height: 48px;
  cursor: pointer;
}

/* 登录*/
.top {
  display: flex;
  align-items: center;
}

.top-text {
  font-size: 18px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #000000;
  line-height: 25px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/proxyHome/index.vue